/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type ClientRepresentativeType = (typeof ClientRepresentativeType)[keyof typeof ClientRepresentativeType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientRepresentativeType = {
  legal_representative: "legal_representative",
  guardian: "guardian",
  power_of_attorney: "power_of_attorney",
} as const;
